// extracted by css-extract-rspack-plugin
export default {"expirationDate":"VisaAlerts__expirationDate--_tLAZ"};